import { render, staticRenderFns } from "./informationList.vue?vue&type=template&id=337bb36a&"
import script from "./informationList.vue?vue&type=script&lang=js&"
export * from "./informationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports